import { ThemeApp } from 'themes/types/themeApp/theme.types';
import sun from '../../../../components/ThemeSwitch/assets/Sun2.svg';
import { themeUi } from '../../themeUi/themeUi';

const components: ThemeApp['appComponents']['components'] = {
  readMore: {
    color: themeUi.semantic.color.border.primary400
  },

  themeSwitch: {
    themeSwitch: {
      borderColor: themeUi.semantic.color.border.transparent,
      backgroundColor: themeUi.semantic.color.border.secondary200,
      knobIcon: `url(${sun})`
    }
  },

  priceBreakDown: {
    footerContainer: {
      borderTop: themeUi.semantic.color.border.secondary300
    }
  },

  aaRequiredCloudResources: {
    container: {
      borderColor: themeUi.semantic.color.border.neutral500,
      borderWidth: '1px',
      borderStyle: 'solid'
    }
  },

  aaRedisLabsPrice: {
    aaRedisLabsDifference: {
      aaRedisLabsPrice: {
        border: themeUi.semantic.color.border.neutral500
      }
    }
  },

  accountAddressDrawer: {
    accountAddressDrawer: {
      sectionContainer: {
        borderBottom: themeUi.semantic.color.border.secondary300
      },
      sectionHeader: {
        color: themeUi.semantic.color.text.secondary950
      }
    },

    components: {
      creditCardSection: {
        creditCardSection: {
          creditCardContainer: {
            backgroundColor: themeUi.semantic.color.background.transparent,
            border: themeUi.semantic.color.border.secondary300
          }
        },

        components: {
          previouslyUsedCC: {
            previousCCWrapper: {
              color: themeUi.semantic.color.text.primary600
            }
          }
        }
      },

      termsOfUse: {
        tosExplanationText: {
          color: themeUi.semantic.color.text.secondary950
        },
        paymentProviderExplanationText: {
          color: themeUi.semantic.color.text.secondary500
        }
      }
    }
  },

  addCreditCardButton: {
    plusContainer: {
      color: themeUi.semantic.color.text.primary400
    },
    plusButton: {
      backgroundColor: themeUi.semantic.color.background.primary600
    }
  },

  addMarketplaceAccountButton: {
    plusContainer: {
      color: themeUi.semantic.color.text.primary400
    }
  },

  addEditCCDialog: {
    components: {
      inputFields: {
        readyOnlyCCDetails: {
          color: themeUi.semantic.color.text.secondary950
        }
      },

      sections: {
        accountAddress: {
          components: {
            readOnlyAddress: {
              components: {
                readOnlyRow: {
                  readOnlyInput: {
                    color: themeUi.semantic.color.text.secondary950
                  }
                }
              }
            }
          }
        },

        sectionHeader: {
          color: themeUi.semantic.color.text.secondary950
        }
      }
    }
  },

  availabilityAzsSelectWrapper: {
    components: {
      availabilityAzSelect: {
        note: {
          color: themeUi.semantic.color.text.secondary500
        }
      }
    }
  },

  banner: {
    variantStyles: {
      noticeBackgroundColor: themeUi.semantic.color.background.notice500,
      noticeColor: themeUi.semantic.color.text.secondary50,
      dangerBackgroundColor: themeUi.semantic.color.background.danger500,
      dangerColor: themeUi.semantic.color.text.secondary50
    }
  },

  contractCard: {
    components: {
      contractCardView: {
        contractTitle: {
          color: themeUi.semantic.color.text.secondary950
        },
        label: {
          color: themeUi.semantic.color.text.secondary500
        },
        value: {
          color: themeUi.semantic.color.text.secondary900
        },
        paymentMethodContainer: {
          borderTop: themeUi.semantic.color.border.neutral400
        }
      }
    }
  },

  crdbInstancesThroughput: {
    opsText: {
      color: themeUi.semantic.color.text.secondary950
    },
    totalThroughputRow: {
      borderTop: themeUi.semantic.color.border.secondary300,
      borderBottom: themeUi.semantic.color.border.secondary300
    }
  },

  customPaymentOption: {
    ccNumber: {
      color: themeUi.semantic.color.text.secondary950
    }
  },

  databaseIcon: {
    emptyDbIcon: {
      selectedFill: themeUi.semantic.color.icon.secondary700,
      unselectedFill: themeUi.semantic.color.icon.secondary700
    }
  },

  editableList: {
    lists: {
      draggableList: {
        components: {
          droppableList: {
            components: {
              draggableItem: {
                item: {
                  backgroundColor: themeUi.semantic.color.background.primary100
                },
                index: {
                  color: themeUi.semantic.color.text.primary400
                },
                grip: {
                  color: themeUi.semantic.color.icon.neutral500
                }
              }
            }
          }
        }
      }
    },

    styles: {
      sharedList: {
        listContainer: {
          border: themeUi.semantic.color.border.neutral400
        }
      },

      sharedListItem: {
        listItem: {
          color: themeUi.semantic.color.text.neutral300
        }
      }
    }
  },

  emptyListsFallback: {
    label: {
      color: themeUi.semantic.color.text.secondary900,
      fontSize: themeUi.core.font.fontSize
    },
    description: {
      color: themeUi.semantic.color.text.secondary900,
      fontSize: themeUi.core.font.fontSize
    }
  },

  expandableTable: {
    column: {
      canExpandColor: themeUi.semantic.color.text.secondary900,
      cantExpandColor: themeUi.semantic.color.text.secondary500
    }
  },

  essentialPlanSelection: {
    components: {
      planDescription: {
        planDescription: {
          container: {
            backgroundColor: themeUi.semantic.color.background.secondary0
          },
          horizontalLine: {
            backgroundColor: themeUi.semantic.color.background.secondary500
          },
          taxesExplanation: {
            color: themeUi.semantic.color.text.secondary500
          }
        },

        components: {
          planDetails: {
            planDetails: {
              textColor: {
                color: themeUi.semantic.color.text.secondary950
              },
              separator: {
                backgroundColor: themeUi.semantic.color.background.secondary950
              }
            },

            components: {
              payAsYouGoInfo: {
                title: {
                  color: themeUi.semantic.color.text.secondary950
                },
                text: {
                  color: themeUi.semantic.color.text.secondary500
                }
              }
            }
          },

          planProperties: {
            propertiesRow: {
              borderBottom: themeUi.semantic.color.border.neutral400
            },
            propertyTextValue: {
              color: themeUi.semantic.color.text.secondary900
            }
          }
        }
      },

      planList: {
        planCard: {
          planCost: {
            color: themeUi.semantic.color.text.secondary900
          },
          alreadyInUseText: {
            color: themeUi.semantic.color.text.secondary500
          },
          selectedAndHoverStyle: {
            color: themeUi.semantic.color.text.secondary950
          },
          container: {
            backgroundColor: themeUi.semantic.color.background.secondary0,
            color: themeUi.semantic.color.text.secondary500
          },
          banner: {
            color: themeUi.semantic.color.text.primary600
          }
        }
      }
    }
  },

  ccMiniCard: {
    components: {
      cardDetailsFooter: {
        tooltip: {
          color: themeUi.semantic.color.text.danger500
        }
      },
      switchCcCard: {
        components: {
          ccSelection: {
            buttonContainer: {
              color: themeUi.semantic.color.text.primary400
            }
          }
        }
      },

      creditCardOptionsList: {
        paymentOptionList: {
          borderTop: themeUi.semantic.color.border.neutral400
        },
        horizontalLine: {
          backgroundColor: themeUi.semantic.color.background.neutral400
        },
        optionContainer: {
          backgroundColor: themeUi.semantic.color.background.neutral400
        }
      },

      ccMiniCardCommonWrapper: {
        marketplaceDisplayId: {
          color: themeUi.semantic.color.text.secondary900,
          fontFamily: themeUi.core.font.fontFamily.regular
        },
        marketplacePlan: {
          color: themeUi.semantic.color.text.secondary950
        }
      },

      ccMiniCardView: {
        circle: {
          backgroundColor: themeUi.semantic.color.background.primary500,
          hoverBackgroundColor: themeUi.semantic.color.background.primary200
        },
        footerItemTitle: {
          color: themeUi.semantic.color.text.secondary500
        },
        footerItemValue: {
          color: themeUi.semantic.color.text.secondary900
        },
        miniCardBody: {
          color: themeUi.semantic.color.text.secondary950
        },
        card: {
          backgroundColor: themeUi.semantic.color.background.secondary0
        },
        placeholder: {
          backgroundColor: themeUi.semantic.color.background.neutral500
        }
      }
    }
  },

  formControls: {
    inputLabelWithInfo: {
      optional: {
        color: themeUi.semantic.color.text.neutral500
      }
    },

    viewPasswordField: {
      password: {
        color: themeUi.semantic.color.text.secondary950,
        backgroundColor: themeUi.semantic.color.background.secondary0
      }
    }
  },

  freeTrialGlobalBanner: {
    separator: {
      backgroundColor: themeUi.semantic.color.background.secondary0
    }
  },

  hiddenListNumber: {
    hoverText: {
      color: themeUi.semantic.color.text.secondary950
    }
  },

  highAvailability: {
    contentContainer: {
      color: themeUi.semantic.color.text.secondary0
    },
    multiZoneText: {
      color: themeUi.semantic.color.text.secondary0
    },
    readMore: {
      color: themeUi.semantic.color.text.secondary0
    }
  },

  loginRelatedComponents: {
    commonContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary0
    },
    titleCss: {
      color: themeUi.semantic.color.text.secondary900
    },
    checkEmailText: {
      color: themeUi.semantic.color.text.secondary900
    },
    clickMessage: {
      color: themeUi.semantic.color.text.secondary900
    }
  },

  memoryAlert: {
    container: {
      backgroundColor: themeUi.semantic.color.background.secondary0
    }
  },

  modalCoverLoader: {
    modalVocerLoadingContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary0
    }
  },

  networkConfig: {
    inputContainer: {
      color: themeUi.semantic.color.text.secondary500
    },
    text: {
      color: themeUi.semantic.color.text.secondary500
    }
  },

  optionBadgeList: {
    optionBadgeItem: {
      border: themeUi.semantic.color.border.secondary0,
      color: themeUi.semantic.color.text,
      backgroundColor: themeUi.semantic.color.background
    }
  },

  pocAccountAlert: {
    pocBannerContainer: {
      superAgentColor: themeUi.semantic.color.text.secondary0,
      notSuperAgentColor: themeUi.semantic.color.text.notice500
    }
  },

  priceValue: {
    priceValueContainer: {
      color: themeUi.semantic.color.text.secondary950
    }
  },

  prices: {
    priceRow: {
      color: themeUi.semantic.color.text.secondary950,
      borderBottom: themeUi.semantic.color.border.neutral400,
      borderBottomColor: themeUi.semantic.color.border.neutral500
    },
    priceExplanation: {
      color: themeUi.semantic.color.text.secondary500
    }
  },

  propertyStatus: {
    disabledProperty: {
      color: themeUi.semantic.color.text.neutral500
    }
  },

  radioButtonGroup: {
    radioButtonsContainer: {
      color: themeUi.semantic.color.text
    }
  },

  redisInsightConnectionModal: {
    heading: {
      color: themeUi.semantic.color.text.secondary950
    },
    endpointSelectionContainer: {
      borderBottom: themeUi.semantic.color.border.neutral400
    }
  },

  regionDisplayField: {
    label: {
      color: themeUi.semantic.color.text.secondary900
    },
    regionValue: {
      color: themeUi.semantic.color.text.secondary950
    },
    regionContainer: {
      color: themeUi.semantic.color.text.secondary900,
      strongColor: themeUi.semantic.color.text.secondary950
    }
  },

  regionDisplayOption: {
    regionOptionContainer: {
      color: themeUi.semantic.color.text.primary600
    }
  },

  regionSelect: {
    title: {
      color: themeUi.semantic.color.text.secondary900
    },
    regionDisplayField: {
      color: themeUi.semantic.color.text.secondary900
    }
  },

  regionListContainer: {
    backgroundColor: themeUi.semantic.color.background.secondary50
  },

  regionSelectList: {
    components: {
      hiddenRegionListToggle: {
        hiddenRegionListToggle: {
          toggleButton: {
            backgroundColor: themeUi.semantic.color.background.secondary0,
            color: themeUi.semantic.color.text.primary600,
            hoverBackgroundColor: themeUi.semantic.color.background.primary200,
            menuOpenBackgroundColor: themeUi.semantic.color.background.primary500,
            menuOpenColor: themeUi.semantic.color.text.secondary0
          }
        },

        tooltipMenuContent: {
          menuContent: {
            list: {
              color: themeUi.semantic.color.text.secondary950
            },
            listItem: {
              backgroundColor: themeUi.semantic.color.background.neutral400
            }
          }
        }
      },

      regionSelectCard: {
        regionSelectCard: {
          regionName: {
            color: themeUi.semantic.color.text.secondary950
          }
        }
      }
    }
  },

  requiredCloudResources: {
    components: {
      cloudResourcesHeader: {
        cloudAccountName: {
          color: themeUi.semantic.color.text.secondary500
        },
        totalPriceContainer: {
          color: themeUi.semantic.color.text.secondary950
        }
      }
    }
  },

  stepTab: {
    list: {
      backgroundColor: themeUi.semantic.color.background.secondary0
    },
    stepNumber: {
      backgroundColor: themeUi.semantic.color.background.primary100
    },
    listItem: {
      color: themeUi.semantic.color.text.primary400,
      activeColor: themeUi.semantic.color.text.secondary0,
      activeBackgroundColor: themeUi.semantic.color.background.primary400,
      activeStepNumberBackgroundColor: themeUi.semantic.color.background.primary500,
      activeHoverColor: themeUi.semantic.color.text.secondary0,
      hoverColor: themeUi.semantic.color.text.primary500,
      hoverStepNumberBackgroundColor: themeUi.semantic.color.background.primary500,
      hoverStepNumberColor: themeUi.semantic.color.text.secondary0
    }
  },

  topBarErrorBoundary: {
    errorInformationText: {
      backgroundColor: themeUi.semantic.color.background.danger500
    }
  },

  trafficLightStatus: {
    trafficLightStatus: {
      circle: {
        backgroundColor: themeUi.semantic.color.background,
        color: themeUi.semantic.color.text.secondary0
      }
    },

    components: {
      bigStatusComponent: {
        emptyCircle: {
          backgroundColor: themeUi.semantic.color.background,
          color: themeUi.semantic.color.text.secondary950
        }
      }
    }
  },

  validateCookiesEnabled: {
    wrapper: {
      backgroundColor: themeUi.semantic.color.background.neutral300
    },
    contentContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary0
    },
    headingText: {
      color: themeUi.semantic.color.text.secondary950
    }
  },

  wistiaPlayer: {
    backgroundColor: themeUi.semantic.color.background.neutral300,
    playerColor: themeUi.semantic.color.text.secondary900
  },

  wrappedTable: {
    tableHeader: {
      borderBottom: themeUi.semantic.color.border.secondary300
    },
    tableTitle: {
      color: themeUi.semantic.color.text.secondary950
    }
  },

  oldPricing: {
    components: {
      oldRequiredCloudResources: {
        subTitle: {
          color: themeUi.semantic.color.text.secondary500
        }
      }
    }
  }
};

export default components;
